import "core-js/modules/es.number.to-fixed.js";
import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-09d87f42"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "d-progress-bar"
};
var _hoisted_2 = {
  "class": "progress"
};
var _hoisted_3 = {
  "class": "text"
};
import { assertNaN } from '@/utils/tools';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DProgressBar',
  props: {
    progress: {
      "default": 0
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var num = computed(function () {
      if (assertNaN(props.progress)) return 0;
      if (props.progress > 100) return 100;
      return props.progress.toFixed(0);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        "class": "active",
        style: _normalizeStyle({
          width: "".concat(num.value, "%")
        })
      }, null, 4), _createElementVNode("span", _hoisted_3, _toDisplayString(num.value) + "%", 1)])]);
    };
  }
});